import React, { useEffect, useRef, useState } from "react";
import DateRange from "./../dashboard/DateRange";
import { getReconciliationReport } from "../../store/actions/paymentActions";
import { useDispatch } from "react-redux";
import DataTable from "../../components/Table";
import { convertDateInFormat, toaster } from "../../utils/utils";
import ReconciliationReportTable from "./ReconciliationReportTable";
import { generatePdf } from "../../utils/generatePdf";
import logo from "../../Assets/logo/logo_2x.svg";
import FilterComponent from "./FilterComponent";

const ReconciliationReport = () => {
  const dispatch = useDispatch();
  const slipRef = useRef(null);
  const [reconciliationReportData, setReconciliationReportData] = useState([]);
  const [selectedRange, setSelectedRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [isGenerating, setIsGenerating] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");
  const [proposalNumberFilter, setProposalNumberFilter] = useState("");
  const userDetails = localStorage.getItem("userDetails");
  const userId = JSON.parse(userDetails).user.code;
  const branchName = JSON.parse(userDetails).user.branch;
  const zone = JSON.parse(userDetails).user.zone;

  useEffect(() => {
    applyDateRange(null, null);
  }, []);

  useEffect(()=>{
      if(filteredData.length === 0 && (statusFilter || proposalNumberFilter)){
        toaster("info", "No records found for the applied filters");
      }
    })

    const filteredData = reconciliationReportData.filter((row) => {
  const matchStatus = statusFilter
    ? row.receiptStatus === statusFilter
    : true;

  const matchProposal = proposalNumberFilter.length === 10
    ? row.proposalNumber?.toString().includes(proposalNumberFilter)
    : true;

  return matchStatus && matchProposal;
});

  const applyDateRange = async (startDate, endDate) => {
    setSelectedRange({ startDate, endDate });
    const payload = {
      fromDate: convertDateInFormat(startDate, "DD-MM-YYYY")
        ? convertDateInFormat(startDate, "DD-MM-YYYY")
        : "",
      toDate: convertDateInFormat(endDate, "DD-MM-YYYY")
        ? convertDateInFormat(endDate, "DD-MM-YYYY")
        : "",
      branchName: branchName,
      userId: userId,
      zone: zone,
    };
    let resp = await dispatch(getReconciliationReport(payload));
    if (resp && resp.body) {
      setReconciliationReportData(resp.body);
    }
  };

  const handlePdfDownload = async () => {
    try {
      setIsGenerating(true);
      await generatePdf(slipRef.current, "ReconciliationReport.pdf");
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <>
      <div className="date-range">
        <DateRange applyDateRange={applyDateRange} />
      </div>

      {reconciliationReportData && reconciliationReportData.length > 0 && (
        <>
          {/* PDF BUTTON */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "12px",
            }}
          >
            <div style={{ flex: 1 }}>
              <FilterComponent
                status={statusFilter}
                onStatusChange={setStatusFilter}
                proposalNumber={proposalNumberFilter}
                onProposalNumberChange={setProposalNumberFilter}
              />
            </div>
            <div
            style={{
              flex: '1',
              display: "flex",
              justifyContent: "flex-end",
              alignItems:'center'
            }}>
            <button
              onClick={handlePdfDownload}
              disabled={isGenerating}
              style={{
                width: "200px",
                opacity: isGenerating ? 0.6 : 1,
                cursor: isGenerating ? "not-allowed" : "pointer",
              }}
            >
              {isGenerating ? "Generating PDF..." : "Download PDF"}
            </button>
            </div>
          </div>

          <div ref={slipRef} className="pdf-wrapper">
            <div className="pdf-header-row">
              <div className="pdf-only-logo">
                <img src={logo} className="pdf-logo"/>
              </div>
            </div>
            
            <ReconciliationReportTable
              reconciliationReportData={filteredData}
              selectedRange={selectedRange}
            />

            <div className="pdf-only-disclaimer">
              This is a system generated reconciliation report.
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ReconciliationReport;
